<template>
  <div>
    <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
      <a-row>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="分类名称">
            <a-select v-model="searchForm.type_id" allowClear show-search option-filter-prop="children" placeholder="请选择分类名称">
              <a-select-option v-for="item in wordTypeList" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="违禁词名称">
            <a-input v-model.trim="searchForm.name" placeholder="请输入违禁词名称" style="width: 100%" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <div class="flex ml20" style="margin-top: 4px">
          </div>
        </a-col>
      </a-row>
    </a-form>

    <!-- 搜索按钮 -->
    <div class="flex-sb">
      <div>
        <a-button type="primary" style="margin-right:55px;" icon="plus-circle" @click="handleAddTag">添加违禁词</a-button>
        <a class="uplod" target="_blank" :href="`${baseURL}/public/forbidden-words-export`">下载模板</a>
        <!-- <a-button class="mr10" type="primary" icon="download" @click="handleDownload">下载模板</a-button> -->
        <a-upload name="file" :showUploadList="false" :headers="{ token }" :action="`${baseURL}/forbidden-words/import`" @change="handleMulImport">
          <a-button>
            <a-icon type="upload" /> 批量导入
          </a-button>
        </a-upload>
      </div>
      <div>
        <a-button type="primary" icon="search" style="margin-right:10px" @click="search">查询</a-button>
        <a-button type="primary" icon="delete" ghost @click="handleClear">清空</a-button>
      </div>
    </div>

    <!-- 表格 -->
    <a-table size="middle" row-key="id" :loading="loading" :columns="columns" :data-source="data" :pagination="pagination" style="margin-top: 20px" @change="handleTableChange">
      <template slot="type_id" slot-scope="text">
        {{ showClassName(text) }}
      </template>
      <template slot="module_select" slot-scope="text, record">
        <div v-if="text === 1">
          <span style="margin-right:20px;" v-for="item in WORDS_MODULES" :key="item.key">{{ item.value }}</span>
        </div>
        <div v-else>
          <span style="margin-right:20px;" v-for="item in getModules(record.forbiddenWordsType.modules)" :key="item.key">{{ item.value }}</span>
        </div>
      </template>
      <template slot="operator" slot-scope="text, record">
        <div>
          <a-button size="small" type="link" style="margin-right:10px;" @click="handleTableCommand('edit', record)">编辑</a-button>
          <a-button size="small" type="link" @click="handleTableCommand('delete',record)">删除</a-button>
        </div>
      </template>
    </a-table>

    <!-- 新增/编辑 -->
    <a-modal v-model="visible" width="40%" :title="title" :afterClose="handleCancel">
      <a-form-model ref="formDom" :model="form" :rules="rules" :label-col="{span: 4}" :wrapper-col="{span: 20}">
        <a-form-model-item label="违禁词分类" prop="type_id">
          <a-select v-model="form.type_id" allowClear show-search option-filter-prop="children" placeholder="请选择">
            <a-select-option v-for="item in wordTypeList" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="违禁词" prop="name">
          <a-input v-model.trim="form.name" placeholder="请输入" />
        </a-form-model-item>
      </a-form-model>
      <template slot="footer">
        <a-button key="back" @click="handleCancel">
          取 消
        </a-button>
        <a-button key="submit" type="primary" :loading="btnLoading" @click="handleSubmit">
          提 交
        </a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import { ref, reactive, onMounted, toRefs, getCurrentInstance, watch, computed } from '@vue/composition-api'
import { strategyCommand, title } from './business/tableLogic'
import { searchForm, columns, rules } from './business/tagList'
import pagination from '@/composables/pagination'
import token from '@/composables/token'
import compuedFun from '../../computed/'
import api from '@/api/'

export default {
  setup(props) {
    // 获取当前实例
    const _this = getCurrentInstance()

    const state = reactive({
      rules,
      columns, // 表头列表
      baseURL: process.env.VUE_APP_API_BASE_URL,
      wordTypeList: [], // 违禁词分类列表
      btnLoading: false, // 按钮loading
      title: title.Add, // 弹窗title
      form: { name: '', type_id: undefined },
      searchForm: { ...searchForm } // 搜索表单
    })

    onMounted(() => {
      methods.getList()
      methods.getWordType()
    })

    watch(
      () => state.searchForm.type_id,
      val => {
        val ? (state.form.type_id = val) : (state.form.type_id = state.searchForm.type_id)
      }
    )

    const methods = {
      getModules(record) {
        const arr = []
        _this.WORDS_MODULES.map(item => {
          record.map(items => {
            if (item.key === items) {
              arr.push(item)
            }
          })
        })
        return arr
      },
      search() {
        _this.pagination.current = 1
        this.getList()
      },

      // 获取列表
      async getList() {
        _this.loading = true
        const res = await api.listWord({
          ...state.searchForm,
          page: _this.pagination.current,
          per_page: _this.pagination.pageSize
        })
        const { forbiddenWords, pagination } = res.data
        _this.data = forbiddenWords
        _this.pagination.total = pagination.total
        _this.loading = false
      },

      // 获取分类
      async getWordType() {
        const res = await api.listTypeWord()
        state.wordTypeList = res.data.forbiddenWordsType
      },

      // 提交编辑
      handleSubmit() {
        _this.$refs.formDom.validate(async valid => {
          if (valid) {
            state.btnLoading = true
            let res
            if (_this.isEdit) {
              res = await api.updateWord(state.form)
            } else {
              res = await api.createWord(state.form)
            }
            if (_this.$validate(res)) {
              this.$message.success(this.isEdit ? '编辑成功~' : '新增成功~')
              methods.getList()
              _this.visible = false
            }
            state.btnLoading = false
          }
        })
      },

      handleMulImport({ file, fileList }) {
        const code = file.response?.code
        const msg = file.response?.message
        if (code && code !== '000000') return _this.$message.warning(msg)
        if (code && code === '000000') {
          _this.$message.success('导入成功~')
          methods.getList()
        }
      },

      async handleDownload() {
        const res = await api.exportWord()
        const link = document.createElement('a')
        const blob = new Blob([res], { type: 'application/vnd.ms-excel' })
        const url = URL.createObjectURL(blob)
        // link.href = url
        // link.download = '国内策略包查询统计表'
        // link.click() // 下载文件
        window.open(url)
      },

      showClassName(id) {
        const item = state.wordTypeList.filter(o => o.id === id)[0]
        return (item && item.name) || '--'
      },

      // 新增标签
      handleAddTag() {
        _this.visible = true
        _this.isEdit = false
        state.title = title.Add
      },

      // 关闭弹窗
      handleCancel() {
        _this.$refs.formDom.resetFields()
        _this.visible = false
        state.btnLoading = false
        state.form.type_id = state.searchForm.type_id
      },

      // 清除
      handleClear() {
        state.searchForm = { ...searchForm }
        this.search()
      },

      // 表格操作
      handleTableCommand(type, data) {
        strategyCommand[type].call(_this, data)
      }
    }

    return {
      ...toRefs(state),
      ...compuedFun(),
      ...pagination(),
      ...token(),
      ...methods
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .ant-tag {
  margin-right: 0;
}
.uplod {
  display: inline-block;
  text-align: center;
  margin-right: 20px;
  width: 93px;
  height: 32px;
  line-height: 32px;
  vertical-align: top;
  border: 1px solid #1890ff;
  border-radius: 4px;
}
</style>
